import { Injectable, Logger, OnApplicationBootstrap } from "@nestjs/common";
import { Interval } from "@nestjs/schedule";
import { GponService } from "../../core/services/gpon.service";
import { OltDB } from "../../core/services/olt_database.service";
import { DDMService } from "./ddm.service";
import { RRDService } from "./rrd_database.service";
import { environment } from "apps/snmp-api/src/environments/environment";
import { DeviceService } from "./device.service";

@Injectable()
export class SchedulerService implements OnApplicationBootstrap {

    private OLTs: number[] = [];
    private runningOltDatacollector = new Set();  // store running datacollector processes by OLT

    constructor(
        private deviceS: DeviceService,
        private ddmS: DDMService, 
        private oltDB: OltDB,
        private gponService: GponService,
        private rrdDB : RRDService) {}

    onApplicationBootstrap() {
        this.loadData();

        var fs = require('fs');
        
        if (!fs.existsSync(environment.rrd_path)){
            fs.mkdirSync(environment.rrd_path, { recursive: true });
        }

        if (!fs.existsSync(environment.png_path)){
            fs.mkdirSync(environment.png_path, { recursive: true });
        }
    }

    @Interval(300000)
    fiveMinCron() {
        this.loadData();
    }
    
    @Interval(150000)
    private updateRrdDBs(){
        this.rrdDB.updateDatabase();
    }
    

    //Every 12h clean the rrd png folder
    @Interval(43200000)
    private deletePngs(){
        const fs = require('fs');
        const path = require('path');

        fs.readdir(environment.png_path, (err, files) => {
        if (err) throw err;

        for (const file of files) {
            fs.unlinkSync(path.join(environment.png_path, file));
        }
        });
    }

    private async loadData() {
        this.OLTs = this.oltDB.getDataCollectorOLTs();
        this.OLTs.every(async oltId => {
            if(!this.runningOltDatacollector.has(oltId)) {
                Logger.log('Olt ' + oltId + ' data collection has started.', 'DataCollector');
                this.runningOltDatacollector.add(oltId);
                if(!this.deviceS.ONTs[oltId]) {
                    this.deviceS.ONTs[oltId] = {};
                }
                
                try {
                    Object.assign(this.deviceS.ONTs[oltId], await this.gponService.getOnts(oltId));
                    // create SN => OltId index
                } catch(err) {
                    Logger.error(err, 'SchedulerService.loadData');
                    return false;
                }
        
                await this.ddmS.getAllData(oltId);
                console.log(this.deviceS.ONTs);
        
                this.runningOltDatacollector.delete(oltId);
                Logger.log('Olt ' + oltId + ' data has been collected.', 'DataCollector');
            }
        })
    }
}